<div [formGroup]="form" class="form-group">
  <label *ngIf="field.label">{{ field.label }}{{ field.validation?.required ? '*' : '' }}</label>
  <input
    #date="bsDatepicker"
    [bsConfig]="bsConfig"
    [minDate]="field.minDate || null"
    [maxDate]="field.maxDate || null"
    type="text"
    bsDatepicker
    class="form-control"
    [placeholder]="field.placeholder"
    [formControlName]="field.name"
  />
  <em (click)="date.toggle()" class="icon-calendar" [ngClass]="{'date-icon-position': field.label}"></em>
  <app-validation-errors
    [control]="form.get(field.name)"
    [field]="field"
  ></app-validation-errors>
</div>
